<div [innerHTML]="message | safeHTML"></div>

<div
*ngIf="showMore"

style="display: flex;
flex-flow: row-reverse;
width: 97%;
font-size: 10px;
margin-bottom: -12px;
cursor: pointer;
"
(click)="toggleShowMore()"
>Read More </div>